export const environment = {
  production: true,
  codespaces: false
};
